const KEY = 'nova-reminder-pins-v1'

export interface PinEntry {
  pinned?: boolean
  x?: number
  y?: number
}

type Store = Record<string, PinEntry>

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? (JSON.parse(raw) as Store) : {}
  } catch {
    return {}
  }
}

function write(s: Store): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s))
  } catch {
    /* ignore */
  }
}

export function getPin(id: string): PinEntry | undefined {
  return read()[id]
}

export function setPinned(id: string, pinned: boolean): void {
  const s = read()
  const cur = s[id] ?? {}
  const next: PinEntry = { ...cur, pinned }
  // Dropping pin with no remembered position → remove the entry entirely.
  if (!pinned && next.x === undefined && next.y === undefined) {
    delete s[id]
  } else {
    s[id] = next
  }
  write(s)
}

export function setPosition(id: string, x: number, y: number): void {
  const s = read()
  s[id] = { ...(s[id] ?? {}), x, y }
  write(s)
}

export function allPinnedIds(): string[] {
  const s = read()
  return Object.keys(s).filter((id) => s[id].pinned === true)
}
